import React from "react";

const SchoolERP = () => {
  return (
    <div className="bg-white">

      {/* HERO SECTION */}
      <section className="py-16 md:py-20 bg-[#f4f7fb]">
        <div className="max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-2 gap-10 md:gap-12 items-center">
          <div className="text-center md:text-left">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0c5a87] mb-4 leading-tight">
              School ERP Software for Modern Educational Institutions
            </h1>

            <p className="text-gray-600 text-base md:text-lg mb-4">
              Gurukul ERP is a powerful cloud-based school management solution
              designed for schools, colleges, and coaching institutes. It
              simplifies administration, improves communication, and enhances
              academic efficiency.
            </p>

            <p className="text-gray-600 text-base md:text-lg mb-6">
              From admission management to examination results, transport
              tracking to fee collection, everything can be managed through a
              secure centralized dashboard.
            </p>

            <a
              href="/contact"
              className="inline-block bg-orange-500 hover:bg-orange-600 transition text-white px-6 md:px-7 py-3 rounded-full text-sm md:text-base"
            >
              Request Demo
            </a>
          </div>

          <div className="flex justify-center items-center">
  <img
    src="/ChatGPT Image Feb 28, 2026, 05_03_03 PM.png"
    alt="School ERP Software Dashboard"
    className="w-full max-w-[650px] rounded-xl shadow-xl h-auto object-contain"
  />
</div>
       </div>
</section>

{/* CORE MODULES */}
<section className="py-20 bg-[#f8fafc]">
  <div className="max-w-7xl mx-auto px-6">
    
    <div className="text-center mb-14">
      <h2 className="text-3xl md:text-4xl font-bold text-[#0c5a87]">
        Complete School ERP Modules
      </h2>
      <div className="w-20 h-1 bg-orange-500 mx-auto mt-4 rounded-full"></div>
    </div>

    <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8">
      {[
        "Admission & Enrollment Management",
        "Student Information System",
        "Attendance Tracking System",
        "Online Fee Management & Accounting",
        "Examination & Result Management",
        "Library Management",
        "Transport Management",
        "Timetable Scheduling",
        "HR & Payroll Management"
      ].map((module, index) => (
        <div
          key={index}
          className="bg-white p-8 rounded-2xl 
          shadow-md hover:shadow-xl 
          transition duration-300 
          border border-gray-100"
        >
          
          {/* Number Badge */}
          <div className="w-12 h-12 flex items-center justify-center 
          bg-orange-100 text-orange-600 
          rounded-full font-semibold mb-6">
            {index + 1}
          </div>

          <h3 className="font-semibold text-lg mb-3 text-[#0c5a87]">
            {module}
          </h3>

          <p className="text-gray-600 text-sm leading-relaxed">
            Streamline operations with automated workflows, real-time
            updates, and centralized data management that improves
            efficiency and reduces manual errors.
          </p>

        </div>
      ))}
    </div>

  </div>
</section>


      {/* HOW IT WORKS */}
      <section className="py-16 md:py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-5 md:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-semibold mb-10 text-[#0c5a87]">
            How Gurukul ERP Works
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div className="text-3xl font-bold text-orange-500 mb-3">01</div>
              <h3 className="font-semibold mb-2">Setup & Configuration</h3>
              <p className="text-gray-600 text-sm md:text-base">
                We configure the ERP according to your institution’s structure,
                classes, departments, and academic policies.
              </p>
            </div>

            <div>
              <div className="text-3xl font-bold text-orange-500 mb-3">02</div>
              <h3 className="font-semibold mb-2">Data Migration</h3>
              <p className="text-gray-600 text-sm md:text-base">
                Existing student and academic records are securely migrated
                into the system.
              </p>
            </div>

            <div>
              <div className="text-3xl font-bold text-orange-500 mb-3">03</div>
              <h3 className="font-semibold mb-2">Go Live & Support</h3>
              <p className="text-gray-600 text-sm md:text-base">
                Your institution goes live with continuous training and
                dedicated support assistance.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* ROLE BASED ACCESS */}
      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <h2 className="text-2xl md:text-3xl font-semibold text-center mb-12 text-[#0c5a87]">
            Role-Based Access for Every User
          </h2>

          <div className="grid md:grid-cols-3 gap-8 text-center">
            {["Admin", "Teachers", "Students"].map((role, index) => (
              <div key={index} className="p-6 border rounded-xl">
                <h3 className="font-semibold text-lg mb-3 text-orange-500">
                  {role}
                </h3>
                <p className="text-gray-600 text-sm md:text-base">
                  Secure dashboard access with customized permissions to view,
                  manage, and monitor relevant data in real-time.
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* SECURITY */}
      <section className="py-16 md:py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-5 md:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-semibold mb-8 text-[#0c5a87]">
            Advanced Data Security & Cloud Infrastructure
          </h2>
          <p className="text-gray-600 text-base md:text-lg max-w-4xl mx-auto">
            Gurukul ERP ensures high-level encryption, regular backups, and
            secure cloud hosting. Your institutional data is protected with
            enterprise-grade security protocols and strict access controls.
          </p>
        </div>
      </section>


      {/* FINAL CTA */}
      <section className="py-16 md:py-20 bg-[#0c5a87] text-white text-center">
        <div className="max-w-4xl mx-auto px-5 md:px-8">
          <h2 className="text-2xl md:text-3xl font-semibold mb-6">
            Ready to Digitize Your School Management?
          </h2>
          <p className="mb-8 text-sm md:text-base">
            Join hundreds of educational institutions that trust Gurukul ERP
            for smart, secure, and simplified school management.
          </p>

          <a
            href="/contact"
            className="inline-block bg-orange-500 hover:bg-orange-600 transition px-8 py-3 rounded-full text-sm md:text-base"
          >
            Schedule a Free Demo
          </a>
        </div>
      </section>

    </div>
  );
};

export default SchoolERP;